export default __webpack_public_path__ + "static/media/primbg.c142ab37.png";